import { render } from "./BagList.vue?vue&type=template&id=3f1ae224&scoped=true"
import script from "./BagList.vue?vue&type=script&lang=js"
export * from "./BagList.vue?vue&type=script&lang=js"

import "./BagList.vue?vue&type=style&index=0&id=3f1ae224&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1ae224"]])

export default __exports__